import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';
import './style.css';
// import Vue3ApexCharts from 'vue3-apexcharts';

const pinia = createPinia();

// Thème (clair/sombre) mémorisé
const theme = localStorage.getItem('theme');
if (theme) {
    document.documentElement.setAttribute('data-theme', theme);
}

// Enregistrement du service worker (PWA)
if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker
            .register('/sw.js')
            .catch((err) => console.error('SW registration failed:', err));
    });
}

createApp(App)
    .use(pinia)
    .use(router)
    // .use(Vue3ApexCharts)
    .mount('#app');
